import Vue from 'vue';

import Loading from './Loading';
import Loader from './Loader';

Vue.component('c-loading', Loading);
Vue.component('c-loader', Loader);
